import Constants from "utilities/js/Constants";
import CookieManager from "../localstorage/CookieManager";
import {logout} from "../ActionLibrary";
let cookieManager = new CookieManager();

class CalloutBuilder {

    //******************************* User Management **********************************/
    login(params){
        const {email, password} = params;

        return makePostCallout(Constants.SERVER_URL + '/login', {
            email: email,
            password: password
        });
    }

    registerUser(params){
        const {username, email, password, firstName, lastName} = params;
        return makePostCallout(Constants.SERVER_URL + '/register', {
            username: username,
            firstName: firstName,
            lastName: lastName,
            email: email,
            password: password
        });
    }
    
    getUserInfo(key){
        return makeGetCallout(Constants.SERVER_URL + '/userinfo', {accountId: key}, true);
    }

    verifyEmail(key){
        return makeGetCallout(Constants.SERVER_URL + '/verify-email', {token: key}, false);
    }

    sendVerifyEmail(body){
        return makePostCallout(Constants.SERVER_URL + '/send-verification-email', {}, true);
    }

    sendResetPasswordEmail(key){
        return makePostCallout(Constants.SERVER_URL + '/send-reset-password-email', {email: key}, false);
    }

    resetPassword(params){
        return makePatchCallout(Constants.SERVER_URL + '/reset-password', params, false);
    }

    getResetPassword(key){
        return makeGetCallout(Constants.SERVER_URL + '/reset-password', {token: key}, false);
    }

    updateAccount(body){
        return makePatchCallout(Constants.SERVER_URL + '/account', body, true);
    }

    getAccountColors(params){
        return makeGetCallout(Constants.SERVER_URL + '/account-colors', {}, true);
    }

    getNotifications(params){
        return makeGetCallout(Constants.SERVER_URL + '/notifications', params, true);
    }

    updateNotifications(body){
        return makePatchCallout(Constants.SERVER_URL + '/notifications', body, true);
    }

    markNotificationsAsRead(body){
        return makePatchCallout(Constants.SERVER_URL + '/read-notifications', body, true);
    }

    clearNotifications(body){
        return makeDeleteCallout(Constants.SERVER_URL + '/clear-notifications', body, true);
    }
    //******************************* Contact Us **********************************/

    submitFeedback(params){
        return makePostCallout(Constants.SERVER_URL + '/submit-feedback', params, false);
    }

    //******************************* Bracket Management **********************************/
    getViewOnlyBracket(key){
        return makeGetCallout(Constants.SERVER_URL + '/view-only-bracket', {bracketId: key}, true);
    }

    getAdminBracket(key){
        return makeGetCallout(Constants.SERVER_URL + '/bracket', {bracketId: key}, true);
    }

    getBrackets(params){
        return makeGetCallout(Constants.SERVER_URL + '/brackets', params, true);
    }

    createBracket(body){
        return makePostCallout(Constants.SERVER_URL + '/bracket', body, true);
    }

    updateBracket(body){
        return makePatchCallout(Constants.SERVER_URL + '/bracket', body, true);
    }

    deleteBracket(body){
        return makeDeleteCallout(Constants.SERVER_URL + '/bracket', body, true);
    }

    //******************************* Search Management **********************************/
    search(params){
        return makeGetCallout(Constants.SERVER_URL + '/search', params, true);
    }

    getAccountInfo(params){
        return makeGetCallout(Constants.SERVER_URL + '/account', params, true);
    }
    
    //******************************* Follow Management **********************************/
    getFollow(params){
        return makeGetCallout(Constants.SERVER_URL + '/following', params, true);
    }
    createFollow(body){
        return makePostCallout(Constants.SERVER_URL + '/following', body, true);
    }
    removeFollow(body){
        return makeDeleteCallout(Constants.SERVER_URL + '/following', body, true);
    }
    getFollowCount(params){
        return makeGetCallout(Constants.SERVER_URL + '/follow-count', params, true);
    }
    getFollows(params){
        return makeGetCallout(Constants.SERVER_URL + '/follows', params, true);
    }
    approveFollowRequest(body){
        return makePatchCallout(Constants.SERVER_URL + '/approve-follow', body, true);
    }
    declineFollowRequest(body){
        return makePatchCallout(Constants.SERVER_URL + '/decline-follow', body, true);
    }
}

function makeGetCallout(endpoint, params, isSecure){

    return new Promise((resolve, reject) => {
        
        let paramString = Object.keys(params).reduce((previous, current, index) => {
            return index === 0 ? '?' + current + '=' + params[current] : previous + '&' + current + '=' + params[current];
        }, '?');

        const url = endpoint + paramString;
        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
            }
        };
        
        if(isSecure){
            let token = cookieManager.getValue(Constants.COOKIE_USER_KEY);
            if(token){
                options.headers['x-access-token'] = cookieManager.getValue(Constants.COOKIE_USER_KEY);
            }
        }

        fetch(url, options).then(response => {
            
            if(response.ok){
                response.json().then(data => {
                    console.log(url);
                    console.dir(data);
                    resolve(data);
                }).catch(error => {
                    if(error.code === 'INVALID_TOKEN'){
                        logout();
                    }
                    console.log(error);
                    reject(error);
                });
            }else{
                response.json().then((error) => {
                    if(error.code === 'INVALID_TOKEN'){
                        logout();
                    }
                    reject(error);
                });
            }
        }).catch(error => {
            if(error.code === 'INVALID_TOKEN'){
                logout();
            }
            console.dir(error);
            reject(error);
        });
    })
}

function makePostCallout(endpoint, body, isSecure){

    return new Promise((resolve, reject) => {

        const url = endpoint;
        const options = {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
            },
            body: JSON.stringify(body)
        };
        
        if(isSecure){
            options.headers['x-access-token'] = cookieManager.getValue(Constants.COOKIE_USER_KEY);
        }

        fetch(url, options).then(response => {
            if(response.ok){
                response.json().then(data => {
                    console.log(url);
                    console.dir(data);
                    resolve(data);
                }).catch(error => {
                    console.log(error);
                    reject(error);
                });

            }else{
                response.json().then((error) => {
                    if(error.code === 'INVALID_TOKEN'){
                        logout();
                    }
                    reject(error);
                })
            }
        }).catch(error => {
            if(error.code === 'INVALID_TOKEN'){
                logout();
            }
            console.dir(error);
            reject(error);
        });
    })
}

function makePatchCallout(endpoint, body, isSecure){

    return new Promise((resolve, reject) => {

        const url = endpoint;
        const options = {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
            },
            body: JSON.stringify(body)
        };
        
        if(isSecure){
            options.headers['x-access-token'] = cookieManager.getValue(Constants.COOKIE_USER_KEY);
        }

        fetch(url, options).then(response => {
            if(response.ok){
                response.json().then(data => {
                    console.log(url);
                    console.dir(data);
                    resolve(data);
                }).catch(error => {
                    console.log(error);
                    reject(error);
                });

            }else{
                response.json().then((error) => {
                    if(error.code === 'INVALID_TOKEN'){
                        logout();
                    }
                    reject(error);
                });
            }
        }).catch(error => {
            if(error.code === 'INVALID_TOKEN'){
                logout();
            }
            console.dir(error);
            reject(error);
        });
    })
}

function makeDeleteCallout(endpoint, body, isSecure){

    return new Promise((resolve, reject) => {

        const url = endpoint;
        const options = {
            method: 'DELETE',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json;charset=UTF-8',
            },
            body: JSON.stringify(body)
        };
        
        if(isSecure){
            options.headers['x-access-token'] = cookieManager.getValue(Constants.COOKIE_USER_KEY);
        }

        fetch(url, options).then(response => {
            if(response.ok){
                response.json().then(data => {
                    console.log(url);
                    console.dir(data);
                    resolve(data);
                }).catch(error => {
                    console.log(error);
                    reject(error);
                });

            }else{
                response.json().then((error) => {
                    if(error.code === 'INVALID_TOKEN'){
                        logout();
                    }
                    reject(error);
                });
            }
        }).catch(error => {
            if(error.code === 'INVALID_TOKEN'){
                logout();
            }
            console.dir(error);
            reject(error);
        });
    })
}

export default CalloutBuilder;